<template>
  <div class="organizations-list">
    <h1 class="page-header" v-if="category.name">{{ category.name }}</h1>
    <ais-instant-search
      v-if="showResults"
      index-name="organizations"
      :search-client="searchClient"
    >
      <ais-search-box>
        <template slot-scope="{ isSearchStalled, refine }">
          <input
            type="search"
            @input="refine($event.currentTarget.value)"
            class="form-control py-5 mb-5 search-box border-primary shadow-dark"
            placeholder="Type an organization name or category"
            aria-label="Type an organization name or category"
            aria-describedby="searchAddon"
            v-on:keydown.enter.prevent="refine($event.currentTarget.value)"
          />
          <div
            class="spinner-border text-primary mb-1 spinner"
            role="status"
            :hidden="!isSearchStalled"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </template>
      </ais-search-box>
      <categories />
      <div
        v-if="
          category.organization &&
          category.organization[this.$store.state.country + '_code'] > 0 &&
          category.organization.active
        "
        class="mt-6"
      >
        <organization-card :item="category.organization" />
      </div>
      <ais-configure
        :hits-per-page.camel="24"
        :filters="filters"
      ></ais-configure>
      <ais-hits>
        <div slot-scope="{ items }" class="container">
          <div class="row mt-6">
            <organization-card
              :item="item"
              v-for="item in items"
              :key="item.id"
            />
          </div>
        </div>
      </ais-hits>
      <ais-state-results>
        <p
          class="text-center"
          slot-scope="{ results: { hits } }"
          v-show="!hits.length"
        >
          No projects in this category
        </p>
      </ais-state-results>
      <div class="container">
        <ais-pagination
          v-on:page-change="onPageChange"
          :class-names="{
            'ais-Pagination-list': 'pagination',
            'ais-Pagination-item': 'page-item',
            'ais-Pagination-link': 'page-link',
          }"
        />
      </div>
    </ais-instant-search>
  </div>
</template>
<script>
import algoliasearch from "algoliasearch";
import OrganizationCard from "../components/OrganizationCard";
import Categories from "../components/Categories";
export default {
  name: "Projects",
  metaInfo() {
    return {
      title: this.title,
    };
  },

  components: {
    OrganizationCard,
    Categories,
  },
  mounted() {
    this.updateList();
  },
  watch: {
    "$store.state.country": function () {
      this.updateList();
    },
    $route(to, from) {
      this.updateList();
    },
  },
  methods: {
    onPageChange() {
      this.$nextTick(function () {
        window.scrollTo({
          top: document.querySelector(".organizations-list").offsetTop - 60,
          left: 0,
          behavior: "smooth",
        });
      });
    },
    updateList() {
      if (this.$route.query.category > 0) {
        this.getCategory(this.$route.query.category);
        this.showResults = false;
        this.$nextTick(function () {
          this.filters =
            this.$store.state.country +
            "_code > 0 AND active:true" +
            " AND organization_category_id:" +
            this.$route.query.category;
          this.$nextTick(function () {
            this.showResults = true;
          });
        });
      } else {
        this.title = "Projects";
        this.showResults = false;
        this.category.name = null;
        this.$nextTick(function () {
          this.filters =
            this.$store.state.country + "_code > 0 AND active:true";
        });
        this.$nextTick(function () {
          this.showResults = true;
        });
      }
    },
    getCategory(id) {
      let self = this;
      this.axios
        .get(window.API_URL + "categories/" + id)
        .then(function (response) {
          self.category.id = response.data.id;
          self.category.name = response.data.name;
          self.title = response.data.name;
          self.category.organization = response.data.organization;
        })
        .catch(function (error) {});
    },
  },
  data() {
    return {
      title: "",
      showResults: true,
      filters: "",
      organizationId: null,
      category: {
        id: null,
        name: null,
      },
      searchParameters: {
        organization_category_id: 1,
      },
      searchClient: algoliasearch(
        "JB7CZTL70W",
        "96798c6c7b3aa65a447ea8cab0603ae6"
      ),
    };
  },
};
</script>
<style lang="scss">
.search-box {
  border-radius: 30px;
}
</style>